<template>
  <div class="card-carousel-wrapper mt-12">
    <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>
    <div class="card-carousel">
      <div class="card-carousel--overflow-container">
        <div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
          <div class="card-carousel--card" v-for="(item, index) in activeItems" :key="index" :class="{'active': value === item.title, 'disabled': disabled_items.includes(item.title)}" @click="updateValue(item.title)">
            <div class="card-carousel--card--footer text-center">
              <span class="new-label items-center" v-if="isNew(item.title)">New</span>
              <span class="soon-label items-center" v-if="isSoon(item.title)">Soon</span>
              <span class="beta-label items-center" v-if="isBeta(item.title)">Beta</span>
              <img class="campaign-objective-imges mt-5 mb-5" :class="isNew(item.title) ? 'new-item': ''" :src="item.image" alt="objective" />
              <h6 class="mb-5 text-lg font-medium"> {{ item.title }} </h6>
              <h4 class="card-subtitle text-sm" v-html="item.subtitle"></h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    disabled_items: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    items: {
      type: Array,
      required: true
    },

    new_items: {
      type: Array,
      required: false
    },

    soon_items: {
      type: Array,
      required: false
    },

    beta_items: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 275,
      activeItems: []
    }
  },
  computed: {
    atEndOfList () {
      const x = window.matchMedia('(max-width: 576px)')

      if (x.matches) {
        return this.currentOffset <= ((this.paginationFactor  + 200) * -1) * (this.items.length + (this.items.length === 5 ? 0 : 1) - this.windowSize)
      } else {
        return this.currentOffset <= (this.paginationFactor * -1) * (this.items.length - this.windowSize)
      }
    },

    atHeadOfList () {
      return this.currentOffset === 0
    }
  },
  watch: {
    items () {
      this.currentOffset = 0

      this.activeItems = this.items
      // TODO: Fix this condition because it applies to any item that has the same ID as this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM
      if (!this.$hasFeature('lead_form')) {
        this.activeItems = this.items.filter(el => el.id !== this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM)
      }

    }
  },
  methods: {
    isNew (title) {
      return this.new_items ? this.new_items.includes(title) : false
    },

    isSoon (title) {
      return this.soon_items ? this.soon_items.includes(title) : false
    },

    isBeta (title) {
      return this.beta_items ? this.beta_items.includes(title) : false
    },
    moveCarousel (direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor
      }
    },
    updateValue (value) {
      if (this.disabled_items.includes(value)) {
        return
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  $vue-navy: #2c3e50;
  $vue-navy-light: #3a5169;
  $vue-teal: #4492e7;
  $vue-teal-light: #42b983;
  $gray: #666a73;
  $light-gray: #f8f8f8;

  .new-label {
    top: 16px;
    left: 16px;
    // left: -42%;
    position: absolute;
    // margin-left: 18px !important;
    background: #db2828;
    border-radius: 20px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    width: 49px !important;
    height: 24px !important;
    padding: 3px 11px 3px 11px;
  }

  .soon-label {
    top: 16px;
    left: 16px;
    position: absolute;
    background: $gray;
    border-radius: 20px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    width: 49px !important;
    height: 24px !important;
    padding: 3px 11px 3px 11px;
  }

  .beta-label {
    top: 16px;
    left: 16px;
    position: absolute;
    background: #ffc107;
    border-radius: 20px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    width: 49px !important;
    height: 24px !important;
    padding: 3px 11px 3px 11px;
  }

  .card-carousel-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 20px 0 40px;
    color: $gray;
  }

  .card-carousel {
    display: flex;
    justify-content: center;
    width: 100%;

    &--overflow-container {
      overflow: hidden;
    }

    &--nav__left,
    &--nav__right {
      display: inline-block;
      width: 15px;
      height: 15px;
      padding: 10px;
      box-sizing: border-box;
      border-top: 2px solid $vue-teal;
      border-right: 2px solid $vue-teal;
      cursor: pointer;
      margin: 0 20px;
      transition: transform 150ms linear;

      &[disabled] {
        opacity: 0.2;
        border-color: black;
      }
    }

    &--nav__left {
      transform: rotate(-135deg);

      &:active {
        transform: rotate(-135deg) scale(0.9);
      }
    }

    &--nav__right {
      transform: rotate(45deg);

      &:active {
        transform: rotate(45deg) scale(0.9);
      }
    }
  }

  .card-carousel-cards {
    display: flex;
    transition: transform 150ms ease-out;
    transform: translateX(0);

    .card-carousel--card {
      margin: 0 10px;
      cursor: pointer;
      box-shadow: none;
      border: 1px solid rgba(153, 153, 153, 0.277289);
      background-color: #fff;
      border-radius: 15px;
      z-index: 3;
      margin-bottom: 2px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      img {
        vertical-align: bottom;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        transition: opacity 150ms linear;
        user-select: none;

        // &:hover {
        //   opacity: 0.5;
        // }
      }

      &--footer {
        border-top: 0;
        padding: 7px 15px;
      }
    }

    .card-subtitle {
      font-size: 12px;
      font-weight: unset !important;
    }

    .card-carousel--card--footer {
      position: relative;
      height: 290px;
      width: 290px;
    }
  }

  // .new-item {
  //   margin-left: -70px !important;
  // }

  @media (max-width: 576px) {
    .card-carousel--card--footer {
      height: 250px !important;
      width: 253px !important;
    }
  }

  .card-carousel--nav__left {
    position: relative;
    left: 40px;
    z-index: 999;
  }

  .card-carousel--nav__right {
    position: relative;
    right: 40px;
    z-index: 999;
  }

  .active {
    border: 1px solid #0092d7 !important;

    h4 {
      color: #0092d7 !important;
    }

    h6 {
      color: #0092d7 !important;
    }

    img {
      filter: grayscale(0%) !important;
    }
  }

  .campaign-objective-imges {
    width: 78px;
    margin-top: 50px !important;
  }

  .disabled {
    h6,
    h4 {
      color: #bdc3ca;
    }

    img {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }

    cursor: not-allowed !important;
  }
</style>
